import script from "./AbstractMentoringOpen.vue?vue&type=script&setup=true&lang=js"
export * from "./AbstractMentoringOpen.vue?vue&type=script&setup=true&lang=js"

import "./AbstractMentoringOpen.vue?vue&type=style&index=0&id=c81e8e50&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c81e8e50"]])

export default __exports__